'use strict';

import {financingRequestModel} from "@js/models/financingrequestmodel";

export class ProjectFinancingReportCtrl
{
	
	report = {};
	classif;
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;		
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.setReport(this.jsDataService.get('report', {}));
	}
	
	setReport(report){
		this.report = new financingRequestModel(report, this.$filter, this.jsDataService);
	}
	
	modelValue(name){
		if(typeof(this.report) !== 'undefined'){
			return this.report.getValue(name);
		}
		return '';
	}
	
	autosavePostFields(){
		let report = {
			id: this.report.id,
			consumption: this.report.consumption
		};
		return {
			report: report
		};
	}
	
	actConfirmEdit(ev){
		const confirmTexts = this.jsDataService.get('editConfirmTexts');
		const confirm = this.$mdDialog.confirm()
			.title(confirmTexts.title)
			.htmlContent(confirmTexts.content)
			.ariaLabel(confirmTexts.title)
			.targetEvent(ev)
			.ok(confirmTexts.ok)
			.cancel(confirmTexts.cancel);
		this.$mdDialog.show(confirm).then(() => {
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgEditConfirmUrl'),
				method: 'GET',
				params: {}
			}).then((results) => {
				if(results.data.success){

				}
			});
		}, () => {});
	}
	
	getClassifValue(value, classifName){
		if(this.classif && typeof(this.classif[classifName]) !== 'undefined'){
			let v = this.$filter('filter')(this.classif[classifName], {id: value}, true);
			if(v.length > 0){
				return v[0].title;
			}
		}
		return '';
	}
	
	actGuaranteeReceipt(ev){
		const cfg = this.jsDataService.get('cfgGuarantee');
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "report", this.guaranteeEditorDialogCtrl],
			templateUrl: 'projects/guarantee_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				report: this.report
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(cfg.saveUrl){
				this.$scope.basicHttpConfigProcess({
					url: cfg.saveUrl,
					method: 'POST',
					data: {
						guarantee_receipt_date: this.$filter('date')(results.guarantee_receipt_date_cet, 'yyyy-MM-dd')
					}
				}).then((response) => {
					if(response.data.success){
						this.report.guarantee_receipt_date_cet = results.guarantee_receipt_date_cet;
					}
				}, () => {});
			}
			else{
				console.log('no url ', cfg.saveUrl);
			}
		}, () => {});
	}
	
	guaranteeEditorDialogCtrl($scope, $mdDialog, report){
		$scope.guarantee_receipt_date_cet;
		if(report.guarantee_receipt_date_cet instanceof Date){
			$scope.guarantee_receipt_date_cet = new Date(report.guarantee_receipt_date_cet.getTime());
		}
		else{
			const dateObj = new Date();
			$scope.guarantee_receipt_date_cet = new Date(dateObj.toLocaleString('eu-eu', {timeZone: 'CET'}));
		}
		
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide({
				guarantee_receipt_date_cet: $scope.guarantee_receipt_date_cet
			});
		};
	}
	
	actPaid(ev){
		const cfg = this.jsDataService.get('cfgPaid');
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "report", this.paidEditorDialogCtrl],
			templateUrl: 'projects/paid_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				report: this.report
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(cfg.saveUrl){
				this.$scope.basicHttpConfigProcess({
					url: cfg.saveUrl,
					method: 'POST',
					data: {
						paid_date: this.$filter('date')(results.paid_date_cet, 'yyyy-MM-dd')
					}
				}).then((response) => {
					if(response.data.success){
						this.report.paid_date_cet = results.paid_date_cet;
					}
				}, () => {});
			}
			else{
				console.log('no url ', cfg.saveUrl);
			}
		}, () => {});
	}
	
	paidEditorDialogCtrl($scope, $mdDialog, report){
		$scope.paid_date_cet;
		if(report.paid_date_cet instanceof Date){
			$scope.paid_date_cet = new Date(report.paid_date_cet.getTime());
		}
		else{
			const dateObj = new Date();
			$scope.paid_date_cet = new Date(dateObj.toLocaleString('eu-eu', {timeZone: 'CET'}));
		}
		
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide({
				paid_date_cet: $scope.paid_date_cet
			});
		};
	}
	
}